import Input from './Input';
import RadioGroup from './RadioGroup';
import Select from './Select';
import Checkbox from './Checkbox';
import Button from './Button';
import ActionButton from './ActionButton';
import InputSlider from './InputSlider';
import Slider from './Slider';

// This exists to create a namespace separate from the equivalent
// MUI components. 
const Controls = {
    Input, 
    RadioGroup,
    Select,
    Checkbox,
    Button,
    ActionButton,
    InputSlider,
    Slider,
}

export default Controls;